var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1034_4052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.703125C3.02148 0.703125 0.203125 3.52148 0.203125 7C0.203125 10.4785 3.02148 13.2969 6.5 13.2969C9.97852 13.2969 12.7969 10.4785 12.7969 7C12.7969 3.52148 9.97852 0.703125 6.5 0.703125ZM7.9498 9.59238L5.71035 7.96484C5.63164 7.90645 5.58594 7.81504 5.58594 7.71855V3.44531C5.58594 3.27773 5.72305 3.14062 5.89062 3.14062H7.10938C7.27695 3.14062 7.41406 3.27773 7.41406 3.44531V6.9416L9.02637 8.11465C9.16348 8.21367 9.19141 8.4041 9.09238 8.54121L8.37637 9.52637C8.27734 9.66094 8.08691 9.69141 7.9498 9.59238Z",
    fill: "#979797"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1034_4052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockIcon);
export default __webpack_public_path__ + "static/media/ClockIcon.34f53b5c499a6d101b15984dd057d292.svg";
export { ForwardRef as ReactComponent };